import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import LayoutPublic from './Layouts/LayoutPublic';
import PageNotFound from './views/Error/PageNotFound';
import './index.css';
import Contacto from "./views/contacto";
import Nosotros from "./views/nosotros";
import Servicios from "./views/servicios";
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
        <Routes>
            <Route path="/" element={<LayoutPublic />}>
                <Route index element={<App />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/nosotros" element={<Nosotros />} />
                <Route path="/servicios" element={<Servicios />} />
                <Route path="*" element={<PageNotFound />} /> 
            </Route>
        </Routes>
    </Router>
);

reportWebVitals();